let userData = {};

export const setUserData = (data) => {
  userData = data;
};

export const getUserData = () => {
  return userData;
};
